<template>
<div class="interactiveDetail">
     <div class='flex-between pad12'>
        <p class="tit">课堂互动</p>
        <p>{{curClass.className}}</p>
     </div>
     <div class='interactionList'>
        <div class="title">{{details.subjectName}}</div>
        <p class="gray flex-between"><span>主讲老师：{{details.teacherName}}</span><span>{{details.interactTime}}</span></p>
        <div class="con1">
            <p class="border"><span class='color'>{{details.studentNum}}</span><br><span class='gray'>参与学生(个)</span></p>
            <p><span class='color'>{{details.accuracy}}</span>%<br><span class='gray'>平均正确率</span></p>
        </div>
     </div>
     <p class="tit pad12">学生答题统计</p>
     <div class="con">
        <div class="head"><p>姓名</p><p>答题</p><p>正确率</p></div>
        <div v-for="(item,i) in list" :key='i'>
              <p>{{item.studentName}}</p>
              <p>{{item.rightNum+item.wrongNum}}</p>
              <p>{{item.accuracy}}%</p>
        </div>
     </div>
</div>
</template>
<script>
import {studentStatOfTeacherList} from "@/api/api.report";
  export default {
    data() {
      return {
        list:[],
        details:'',
        curClass:'',
        details:''
      }
    },
    created(){
         this.curClass=JSON.parse(sessionStorage.classes);
         this.details=JSON.parse(sessionStorage.details);
         this.getDetail();
    },
    methods: {
      getDetail(){
         studentStatOfTeacherList({
              subjectId:this.details.subjectId,
              classId:this.curClass.classId,
              interactId:this.details.interactId,
           }).then((data) => {
             this.list=data.result;
             
           })
      },
    },
  }
</script>
<style lang="scss">
.interactiveDetail{
  padding:.15rem;
  .tit{
    margin-bottom: .1rem;
    color: #000;
    font-weight: bold;
    font-size: .15rem;
  }
  .pad12{
    padding:0px 12px;
  }
  .interactionList{
    padding:.12rem .12rem .16rem;
    background:#fff;
    border-radius: 12px;
    font-size: .14rem;
    color: #333;
    margin-bottom: .16rem;
    .title{
        font-size: .16rem;
        margin-bottom: .05rem;
        font-weight: bold;
    }
    .con1{
       display: flex;
       margin-top: .24rem;
       p{
         flex: 1;
         text-align: center;
         position: relative;
         .color{
            font-size:.23rem;
            margin-right: 5px;
            margin-bottom: .04rem;
            display: inline-block;
         }
         &.border::after{
              content: '';
              width: 1px;
              height: 50%;
              display: inline-block;
              position: absolute;
              background:rgba(0,0,0,.2);
              top: 30%;
              right: 0px;
         }
       }
    }
  }
  .con{
      background: #fff;
      border-radius: 12px;
      padding:.1rem .15rem .2rem;
      div{
        display: flex;
        padding:.1rem 0rem;
        border-bottom:1px solid #E5E5E5;
        font-size: .13rem;
        align-items: center;
        &:last-child{
          border-bottom: none;
        }
        p{
          flex:1;
          text-align: center;
          &:first-child{
            flex:0 0 44%;
            text-align: left;
            padding-left: .12rem;
          }
        }
        .absence{
          border-radius: 3px;
          border:1px solid #ED6F21;
          color:#ED6F21;
          margin-left:.1rem;
          font-size: .12rem;
          padding:1px 2px;
          display: inline-block;
        }
        &.head{
          font-weight: 550;
          font-size: .15rem;
        }
      }
    }
    .gray{
            font-size: .12rem;
             color:rgba(0,0,0,.6);
     }
   
}
</style>